<div class="snip-overlay"
     (pointerdown)="onPointerDown($event)"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)">
  <div class="snip-instruction-bar" (pointerdown)="$event.stopPropagation()">
    <span class="snip-instruction-text">
      Drag a rectangle for: <strong>{{ attributeLabel }}</strong>
      <span class="snip-instruction-hint">(Esc to cancel)</span>
    </span>
    <button type="button" class="snip-cancel-btn" (click)="onCancelClick($event)">Cancel</button>
  </div>
  @if (selection) {
    <div class="snip-selection"
         [style.left.px]="selection.left"
         [style.top.px]="selection.top"
         [style.width.px]="selection.width"
         [style.height.px]="selection.height"></div>
  }
</div>
